import { render, staticRenderFns } from "./copyrightRegistration.vue?vue&type=template&id=ccf4817c&scoped=true&"
import script from "./copyrightRegistration.vue?vue&type=script&lang=js&"
export * from "./copyrightRegistration.vue?vue&type=script&lang=js&"
import style0 from "./copyrightRegistration.vue?vue&type=style&index=0&id=ccf4817c&prod&lang=less&scoped=true&"
import style1 from "./copyrightRegistration.vue?vue&type=style&index=1&id=ccf4817c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf4817c",
  null
  
)

export default component.exports